import { useMutation, useQueryClient } from "@tanstack/react-query";
import locationBulkUpdateService from "../../../services/locations/bulkUpdateService";

export const useCreateBulkUpdate = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(locationBulkUpdateService.create, {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.invalidateQueries("locations");
      mutationOptions.onSuccess && mutationOptions.onSuccess(data);
    },
  });
};

export const useDestroyBulkUpdate = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(locationBulkUpdateService.delete, {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.invalidateQueries("locations");
      mutationOptions.onSuccess && mutationOptions.onSuccess(data);
    },
  });
};
